import { IAiReport, IAiReportSection } from './ai-report-view.interface';

const HTML_ESCAPES: Record<string, string> = { '"': '&quot;', '&': '&amp;', "'": '&#39;', '<': '&lt;', '>': '&gt;' };

/** Escapes text for HTML, so nothing in an AI answer can turn into markup. */
export function escapeHtml(text: string): string {
  return text.replace(/["&'<>]/g, (character: string) => HTML_ESCAPES[character]);
}

function toSectionHtml(section: IAiReportSection): string {
  return [
    `<p><strong>${escapeHtml(section.heading)}</strong></p>`,
    ...section.paragraphs.map((paragraph: string) => `<p>${escapeHtml(paragraph)}</p>`),
    section.bullets.length
      ? `<ul>${section.bullets.map((bullet: string) => `<li>${escapeHtml(bullet)}</li>`).join('')}</ul>`
      : '',
  ].join('');
}

/**
 * A report as comment HTML: the attribution line (the comment is the user's, the text the agent's), then the title,
 * summary and sections. Only tags the comment editor can open again, and every piece of text is escaped.
 */
export function aiReportToCommentHtml(report: IAiReport, attribution: string): string {
  return [
    `<p><em>${escapeHtml(attribution)}</em></p>`,
    `<p><strong>${escapeHtml(report.title)}</strong></p>`,
    report.summary ? `<p>${escapeHtml(report.summary)}</p>` : '',
    ...report.sections.map(toSectionHtml),
  ].join('');
}
